import WavedBox from '../../../../installation/modules/protocol/protocols/WavedBox';
import betaProcessorTypes from './processorTypes_Beta.generated.json';
import connectionTypes from './connectionTypes.json';

const processorTypes = {

    ...betaProcessorTypes,

    LONDON: {
        value: 'LONDON',
        label: 'BSS Soundweb London',
        connection: connectionTypes.TCP,
        hasMute: true,
        useMuteAddress: true
    },
    YAMAHA: {
        value: 'YAMAHA',
        label: 'Yamaha',
        connection: connectionTypes.TCP
    },
    BOSE: {
        value: 'BOSE',
        label: 'Bose',
        connection: connectionTypes.TCP
    },
    SONOS: {
        value: 'SONOS',
        label: 'Sonos',
    },
    GENELEC: {
        value: 'GENELEC',
        label: 'Genelec',
    },
    WAVEDBOX: {
        value: 'WAVEDBOX',
        label: 'Waved Box',
        connection: connectionTypes.SERIAL,
        predefinedConfig: WavedBox.getPredefinedConfig()
    },  
    BIAMP: {
        value: 'BIAMP',
        label: 'Biamp Tesira',
        connection: connectionTypes.TCP,
    },
    NEXIA: {
        value: 'NEXIA',
        label: 'Biamp Nexia',
        connection: connectionTypes.TCP,
    },
    XILICA: {
        value: 'XILICA',
        label: 'Xilica',
        connection: connectionTypes.TCP,
    },
    QSYS: {
        value: 'QSYS',
        label: 'QSys',
        connection: connectionTypes.TCP,
    },
    SYMETRIX: {
        value: 'SYMETRIX',
        label: 'Symetrix',
        connection: connectionTypes.TCP,
    },
    AUDAC_MTX: {
        value: 'AUDAC_MTX',
        label: 'Audac MTX',
        connection: connectionTypes.TCP,
    },
    AUDAC_M2: {
        value: 'AUDAC_M2',
        label: 'Audac M2',
        connection: connectionTypes.TCP,
    },
    AUDAC_LUNA_F: {
        value: 'AUDAC_LUNA_F',
        label: 'Audac Luna F',
        connection: connectionTypes.TCP,
    },
    AUDAC_LUNA_U: {
        value: 'AUDAC_LUNA_U',
        label: 'Audac Luna U',
        connection: connectionTypes.TCP,
    },
    DBXZONEPRO: {
        value: 'DBXZONEPRO',
        label: 'Dbx ZonePro',
        connection: connectionTypes.TCP,
    },
    BOSCH: {
        value: 'BOSCH',
        label: 'Bosch',
        connection: connectionTypes.TCP,
    },
    SYMETRIX_JUPITER: {
        value: 'SYMETRIX_JUPITER',
        label: 'Symetrix Jupiter',
        connection: connectionTypes.TCP,
    },
    ALLEN_HEATH: {
        value: 'ALLEN_HEATH',
        label: 'Allen & Heath',
        connection: connectionTypes.TCP,
    },
    KRAMER: {
        value: 'KRAMER',
        label: 'Kramer',
        connection: connectionTypes.TCP,
    },
    K_ARRAY: {
        value: 'K_ARRAY',
        label: 'K-Array',
        connection: connectionTypes.TCP, // Really HTTP
    },
    BEATMIX: {
        value: 'BEATMIX',
        label: 'BeatMix (music player)',
        connection: connectionTypes.HTTPS, // Really HTTP
        isMusicPlayer: true,
    },
    LOXONE: {
        value: 'LOXONE',
        label: 'Loxone',
        connection: connectionTypes.TCP, // REALLY WEB SOCKET BUT USING TCP TO PASS IP
        useCredentials: true,
    },
    CRESTRON: {
        value: 'CRESTRON',
        label: 'Crestron',
        connection: connectionTypes.TCP,
    },
    BOSE_POWERSHAREX: {
        value: 'BOSE_POWERSHAREX',
        label: 'Bose PowerShareX',
        connection: connectionTypes.TCP, // REALLY UDP BUT USING TCP TO PASS IP
    },
    POWERSOFT: {
        value: 'POWERSOFT',
        label: 'Powersoft',
        connection: connectionTypes.TCP, // really HTTP but using TCP to pass IP
    },
    QSYS_NAMED_CONTROL: {
        value: 'QSYS_NAMED_CONTROL',
        label: 'QSys Named Control',
        connection: connectionTypes.TCP, // like QSys but with a different API
        hasMute: true,
        useMuteAddress: true
    },
    CONTROL4: {
        value: 'CONTROL4',
        label: 'Control4',
        connection: connectionTypes.TCP,
    },
    NONE: {
        value: 'NONE',
        label: 'None',
    }
};


export {
    processorTypes,
    connectionTypes
};
